var moduleMap = {
	"./SuspenseLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(398)]).then(function() { return function() { return (__webpack_require__(551)); }; });
	},
	"./ProfileSuspenseLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(814), __webpack_require__.e(761)]).then(function() { return function() { return (__webpack_require__(4419)); }; });
	},
	"./TransfersSuspenseLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(598), __webpack_require__.e(674)]).then(function() { return function() { return (__webpack_require__(4153)); }; });
	},
	"./OperationHistorySearchSkeleton": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(598), __webpack_require__.e(953)]).then(function() { return function() { return (__webpack_require__(1103)); }; });
	},
	"./OperationHistorySuspenseLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(598), __webpack_require__.e(953)]).then(function() { return function() { return (__webpack_require__(2953)); }; });
	},
	"./TransfersP2PSuspenseLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(398)]).then(function() { return function() { return (__webpack_require__(179)); }; });
	},
	"./TransfersHomeAutoSuspenseLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(814), __webpack_require__.e(598), __webpack_require__.e(286)]).then(function() { return function() { return (__webpack_require__(8555)); }; });
	},
	"./ProductCardSuspenseLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(814), __webpack_require__.e(674)]).then(function() { return function() { return (__webpack_require__(4610)); }; });
	},
	"./ProfileLinkingCardSuspenseLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(761)]).then(function() { return function() { return (__webpack_require__(944)); }; });
	},
	"./ProfileCertificatedAndExtractsSuspenseLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(814), __webpack_require__.e(398)]).then(function() { return function() { return (__webpack_require__(9909)); }; });
	},
	"./WeInSocialMediaLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(814), __webpack_require__.e(761)]).then(function() { return function() { return (__webpack_require__(2023)); }; });
	},
	"./OrderDebitCardSuspenseLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(814), __webpack_require__.e(286)]).then(function() { return function() { return (__webpack_require__(2706)); }; });
	},
	"./SigningDocumentsSuspenseLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(398)]).then(function() { return function() { return (__webpack_require__(5939)); }; });
	},
	"./ChargeSuspenseLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(814), __webpack_require__.e(260), __webpack_require__.e(634)]).then(function() { return function() { return (__webpack_require__(1634)); }; });
	},
	"./LoyaltyProgramsLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(814), __webpack_require__.e(398)]).then(function() { return function() { return (__webpack_require__(3734)); }; });
	},
	"./BillboardSuspenseLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(286)]).then(function() { return function() { return (__webpack_require__(6689)); }; });
	},
	"./ProductDisplaySettingsSuspenseLoader": function() {
		return Promise.all([__webpack_require__.e(836), __webpack_require__.e(814), __webpack_require__.e(761)]).then(function() { return function() { return (__webpack_require__(9689)); }; });
	},
	"./OpeningCurrentAccountSuspenseLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(398)]).then(function() { return function() { return (__webpack_require__(4387)); }; });
	},
	"./FinProtectPaymentLoader": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(598), __webpack_require__.e(398)]).then(function() { return function() { return (__webpack_require__(8163)); }; });
	},
	"./FavoritesBlockSkeleton": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(598), __webpack_require__.e(674)]).then(function() { return function() { return (__webpack_require__(452)); }; });
	},
	"./OperationHistoryToggleButtonsSkeleton": function() {
		return Promise.all([__webpack_require__.e(305), __webpack_require__.e(836), __webpack_require__.e(598), __webpack_require__.e(953)]).then(function() { return function() { return (__webpack_require__(122)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});